import { render } from "./VisaMinne.vue?vue&type=template&id=bd1e6b54&scoped=true"
import script from "./VisaMinne.vue?vue&type=script&lang=js"
export * from "./VisaMinne.vue?vue&type=script&lang=js"

import "./VisaMinne.vue?vue&type=style&index=0&id=bd1e6b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1e6b54"]])

export default __exports__